import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SmartFilterCategory } from '../models/automation/smart-filter-category';
import { EditSmartFilterCategoryModalComponent } from '../views/smart-filters/modal/edit-smart-filter-category-modal/edit-smart-filter-category-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';

export class ModalEditSmartFilterCategory {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    editCategory?: SmartFilterCategory,
    onClose?: (req: SmartFilterCategory) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(EditSmartFilterCategoryModalComponent, ModalUtils.defaultModalOptions(injector));
      const compInstance = modalRef.componentInstance as EditSmartFilterCategoryModalComponent;
      compInstance.viewModel.isEditing = editCategory !== null;
      const editCategoryCopy = window.injector.Deserialize.instanceOf(SmartFilterCategory, editCategory);
      compInstance.viewModel.existingSmartFilterCategory.next(editCategoryCopy);
      modalRef.result
        .then(createdFilterCategory => {
          if (exists(createdFilterCategory) && exists(onClose)) {
            onClose(createdFilterCategory);
          }
        })
        .catch(() => {});
    });
  }
}
